import { AnyAction, combineReducers } from 'redux'

import userState, { logOut } from '../authorization/userSlice'
import { reducer as loadingState } from '@sales-center/common'
import salesFunnelState from '../salesFunnel/slice'
import editSalesFunnel from '../salesFunnel/editSlice'
import salesTeam from '../salesTeam/slice'
import branches from '../branches/slice'
import employeesState from '../employee/slice'
import companySetup from '../companySetup/slice'
import companyHeaderDisplaySettings from '../companyHeaderDisplaySettings/slice'
import users from '../users/slice'
import leadsState from '../lead/slice'
import serviceProducts from '../serviceProducts/slice'
import leadOppProducts from '../leadOppProducts/slice'
import locationDocuments from '../locationDocuments/slice'
import serviceFrequency from '../serviceFrequency/slice'
import opportunitiesState from '../opportunity/slice'
import roles from '../roles/slice'
import divisions from '../divisions/slice'
import locationTypes from '../locationTypes/slice'
import locations from '../locations/slice'
import targetPests from '../targetPests/slice'
import agreements from '../agreements/slice'
import payments from '../payments/slice'
import dashboard from '../dashboard/slice'
import leadNotes from '../leadNotes/slice'
import opportunityNotes from '../opportunityNotes/slice'
import opportunityAddState from '../opportunity/addOpportunity/addOpportunitySlice'
import locationNotes from '../locationNotes/slice'
import draftLeads from '../draftLeads/slice'
import attachments from '../attachments/slice'
import campaigns from '../campaigns/slice'
import sources from '../sources/slice'
import notifications from '../notifications/slice'
import userPreferences from '../userPreferences/slice'
import salesFunnelSummary from '../salesFunnelSummary/slice'
import entityLocations from '../entityLocations/slice'
import discountCode from '../discountCode/slice'
import tenantFeatures from '../tenantFeatures'
import {
  customFieldOptionsReducer as customFieldOptions,
  customFieldsReducer as customFields,
} from '../customFields'
import { customFieldsSettingsReducer as customFieldsFormSettings } from '../customFieldSettings'
import { initialState } from '../initialStoreState'
import entityFormSettings from '../entityFormSettings/slice'
import entityAppointments from '../scheduling/slice'
import entityAppointmentsSearch from '../scheduling/searchSlice'
import cancelReasons from '../scheduling/cancelReasonsSlice'
import techs from '../techs/slice'
import techRegions from '../techRegions/slice'
import overdueActivitiesCount from '../../features/Activity/store/slice'
import assignmentRules from '../leadAssignmentRule/slice'
import dictionaries from '../dictionaries/slice'
import userPreferencesGeneral from '../userPreferences/userPreferencesGeneral/slice'
import globalSearch from '../globalSearch/slice'
import callTrackingProviders from '../callTracking/slice'
import imports from '../import/slice'
import license from '../licensing/slice'
import salesCenterWebhooks from '../scWebHooks/slice'
import map from '../map/slice'
import territory from '../territory/slice'
import territoryDraw from '../territoryDraw/slice'
import workWaveContactDuplicates from '../duplicates/WorkwaveContacts/slice'
import pestPacLocationDuplicates from '../duplicates/PestPacLocations/slice'
import guestUser from '../guestUser/slice'
import knockStatus from '../knockStatus/slice'

const combinedReducer = combineReducers({
  attachments,
  employeesState,
  loadingState,
  userState,
  companySetup,
  companyHeaderDisplaySettings,
  salesFunnelState,
  editSalesFunnel,
  salesTeam,
  branches,
  users,
  leadsState,
  locationDocuments,
  serviceProducts,
  leadOppProducts,
  serviceFrequency,
  opportunitiesState,
  roles,
  divisions,
  locationTypes,
  locations,
  targetPests,
  agreements,
  payments,
  dashboard,
  leadNotes,
  opportunityNotes,
  locationNotes,
  draftLeads,
  campaigns,
  sources,
  notifications,
  userPreferences,
  salesFunnelSummary,
  entityLocations,
  discountCode,
  tenantFeatures,
  customFields,
  customFieldOptions,
  entityFormSettings,
  customFieldsFormSettings,
  entityAppointments,
  entityAppointmentsSearch,
  cancelReasons,
  techs,
  techRegions,
  overdueActivitiesCount,
  assignmentRules,
  dictionaries,
  opportunityAddState,
  userPreferencesGeneral,
  globalSearch,
  callTrackingProviders,
  imports,
  license,
  salesCenterWebhooks,
  map,
  territory,
  territoryDraw,
  workWaveContactDuplicates,
  pestPacLocationDuplicates,
  guestUser,
  knockStatus,
})

export type RootState = ReturnType<typeof combinedReducer>

export const rootReducer = (state: RootState, action: AnyAction) => {
  if (action.type === logOut.type) {
    state = initialState
  }
  return combinedReducer(state, action)
}
